import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { AlertDialogModule } from '@portal-core/general/components/alert-dialog/alert-dialog.module';
import { InlineButtonModule } from '@portal-core/ui/button/components/inline-button/inline-button.module';
import { ProjectAvatarComponent } from './project-avatar.component';

@NgModule({
  imports: [
    CommonModule,
    InlineButtonModule,
    MatDialogModule,
    MatIconModule,
    MatTooltipModule,
    AlertDialogModule,
    RouterModule
  ],
  declarations: [
    ProjectAvatarComponent
  ],
  exports: [
    ProjectAvatarComponent
  ]
})
export class ProjectAvatarModule { }
